"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Card = void 0;
var _react = _interopRequireDefault(require("react"));
var _TextStack = require("../TextStack");
var _CardModule = _interopRequireDefault(require("./Card.module.css"));
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var Card = _ref => {
  var className = _ref.className,
    label = _ref.label,
    primaryText = _ref.primaryText,
    secondaryText = _ref.secondaryText;
  return /*#__PURE__*/_react.default.createElement(_TextStack.TextStack, {
    className: (0, _classnames.default)(_CardModule.default.Container, className),
    label: label,
    primaryText: primaryText,
    secondaryText: secondaryText
  });
};
exports.Card = Card;
//# sourceMappingURL=Card.js.map